<template>
  <div class="image-content-display-percent">
    <fieldset>
      <legend>画像サイズ</legend>
      <div class="flex-center">
        <span>{{ minInputPercent }}%</span>
        <input
          class="slider-input"
          type="range"
          v-model="inputPercent"
          step="1"
          :min="minInputPercent"
          :max="maxInputPercent"
          @change="reflectDisplayPercent($event.target.value)"
        >
        <span>
          <div class="common-input">
            <input
              type="number"
              v-model="inputPercent"
              @change="reflectDisplayPercent($event.target.value)"
            >
            <div class="size-button plus-button-wrapper">
              <button
                class="plus-button"
                @mousedown="countInputPercent('plus')"
                @mouseup="changeInputPercent('plus')"
                @mouseleave="changeInputPercent('plus')"
              />
            </div>
            <div class="size-button minus-button-wrapper">
              <button
                class="minus-button"
                @mousedown="countInputPercent('minus')"
                @mouseup="changeInputPercent('minus')"
                @mouseleave="changeInputPercent('minus')"
              />
            </div>
          </div>
        </span>
      </div>
    </fieldset>
  </div>
</template>

<script>
const MAX_INPUT_PERCENT = 100
const MIN_INPUT_PERCENT = 10

export default {
  props: [
    'ids',
    'displayPercent'
  ],
  data () {
    return {
      inputPercent: 0,
      maxInputPercent: MAX_INPUT_PERCENT,
      minInputPercent: MIN_INPUT_PERCENT,
      interval: null,
    }
  },
  methods: {
    initValue () {
      this.inputPercent = this.displayPercent
    },
    reflectDisplayPercent (value) {
      let checkValue = Number(value)
      // 空欄や数値以外の場合は更新しない
      if (!value || !Number.isInteger(checkValue)) {
        this.inputPercent = this.displayPercent
        return
      }

      // 最大値より大きい値は最大値に変更
      if (checkValue > this.maxInputPercent) {
        checkValue = this.maxInputPercent
      }
      // 最小値より小さい値は最小値に変更
      if (checkValue < this.minInputPercent) {
        checkValue = this.minInputPercent
      }

      this.$store.dispatch('reflectImage', {
        ...this.ids,
        attrs: { 'data-display-percent': checkValue },
      })
      this.inputPercent = checkValue
    },
    countInputPercent (target) {
      // 必ず1は増減させる
      if (target === 'plus' && this.inputPercent < MAX_INPUT_PERCENT) this.inputPercent++
      if (target === 'minus' && this.inputPercent > MIN_INPUT_PERCENT) this.inputPercent--

      // 長押しで入力値を増減させる
      if (!this.interval) {
        this.interval = setInterval(() => {
          if (target === 'plus' && this.inputPercent < MAX_INPUT_PERCENT) this.inputPercent++
          if (target === 'minus' && this.inputPercent > MIN_INPUT_PERCENT) this.inputPercent--
        }, 100)
      }
    },
    changeInputPercent (target) {
      // 増減を解除
      clearInterval(this.interval)
      this.interval = null

      // プレビューの画像に入力値を適用する
      this.reflectDisplayPercent(this.inputPercent)
    },
  },
  mounted () {
    this.initValue()
  },
  watch: {
    'ids.partId' () {
      this.initValue()
    }
  }
}
</script>

<style lang="scss" scoped>
.image-content-display-percent {
  padding: 20px 0 10px;
  fieldset {
    legend {
      font-size: 14px;
      margin-bottom: 5px;
    }
    .common-input {
      input[type="number"]::-webkit-outer-spin-button,
      input[type="number"]::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
      input[type="number"] {
        -moz-appearance:textfield;
      }
      width: 70px;
      &::after {
        content: '%';
        color: $commonFontColor;
        position: absolute;
        top: 10px;
        right: 24px;
      }
      // 画像サイズ入力：プラスマイナス共通スタイル
      .size-button {
        width: 15px;
        height: 15px;
        position: absolute;
        // ボタン本体 共通スタイル
        button {
          cursor: pointer;
          width: 0;
          height: 0;
          position: absolute;
        }
      }
      // 画像サイズ入力：プラス
      .plus-button-wrapper {
        top: 4px;
        right: 4px;
        .plus-button {
          position: absolute;
          top: 8px;
          right: 2px;
          border-style: solid;
          border-width: 0 4.5px 6px 4.5px;
          border-color: transparent transparent #666666 transparent;
          &:hover {
            border-color: transparent transparent #aaaaaa transparent;
          }
        }
      }
      // 画像サイズ入力：マイナス
      .minus-button-wrapper {
        bottom: 2px;
        right: 4px;
        .minus-button {
          position: absolute;
          bottom: 8px;
          right: 2px;
          border-style: solid;
          border-width: 6px 4.5px 0 4.5px;
          border-color: #666666 transparent transparent transparent;
          &:hover {
            border-color: #aaaaaa transparent transparent transparent;
          }
        }
      }
    }
    .flex-center {
      display: flex;
      align-items: center;
      span {
        font-size: 12px;
        margin: 0 5px;
        vertical-align: middle;
      }
      input.slider-input {
        width: 250px;
        vertical-align: middle;
      }
    }
  }
}
</style>
